import { Box, Skeleton, Stack, styled } from "@mui/material";
import { ItemSkeleton } from "src/components";

const Container = styled(Box)`
  border: solid 1px ${({ theme }) => theme.palette.grey[200]};
  background-color: ${({ theme }) => theme.palette.grey[100]};
  border-radius: 10px;
  padding: ${({ theme }) => theme.spacing(0.5)};
`;

interface Props {
  isTableView?: boolean;
  renderSkeleton?: () => React.ReactNode;
}

const AccordionSkeleton = (props: Props) => {
  return (
    <Container>
      <Stack spacing={0.5}>
        {props.renderSkeleton
          ? props.renderSkeleton()
          : [...Array(3)].map((_, i) =>
              props.isTableView ? (
                <Skeleton variant="rectangular" key={i} height={30} />
              ) : (
                <ItemSkeleton variant="card" key={i} />
              ),
            )}
      </Stack>
    </Container>
  );
};

export { AccordionSkeleton };
